// Field Model
cv.Field = Backbone.Model.extend({
	defaults : {
	},

	initialize: function(){
		console.log('Field model loaded.');
	}
});

// Field Collection
cv.FieldList = Backbone.Collection.extend({
	initialize: function(){
		console.log('FieldList loaded.');
	},

	model: cv.Field
});
